import { BrowserRouter } from 'react-router'

import AuthLayout from '@/components/layouts/AuthLayout'
import ProductConfigProvider from '@/components/ProductConfigProvider'
import Router from '@/components/Router'

const App = () => {
  return (
    <BrowserRouter basename={import.meta.env.VITE_BASE_PATH}>
      <ProductConfigProvider>
        <AuthLayout>
          <Router />
        </AuthLayout>
      </ProductConfigProvider>
    </BrowserRouter>
  )
}

export default App
